import * as React from 'react';
import { CircularProgress, Typography, Box, Button } from '@mui/material';
import UploadVideoList from './UploadVideoList';
import { styled } from '@mui/material/styles';
import { useDispatch} from 'react-redux';
import { productUpdated, productUploadedVideo } from 'features/products/productsSlice';
import { videoAdded } from 'features/videos/videosSlice';

const UploadInput = styled('input')({
    display: 'none',
  });

const UploadVideo = (props) => {

    const { product } = props;

    const [isUploading, setIsUploading] = React.useState(false);
    const [uploadError,setUploadError] = React.useState(null);
    const [file, setFile] = React.useState(null);

    const dispatch = useDispatch();

    const chooseVideo = (event) => {

        

        if(event.target.files.length == 1) {
            let filesize = ((event.target.files[0].size/1024)/1024).toFixed(4);
            if(filesize > 20) {
                alert('Video file is to big. Max file size 20MB');
                return;
            }
            setFile(event.target.files[0]);
        }

    }

    const deleteChoosenVideo = (index) => setFile(null);

    const uploadVideo = (event) => {

        let VideoForm = new FormData();
    
        VideoForm.append("video",file);
        VideoForm.append("videoable_type", "product");
        VideoForm.append("videoable_id",parseInt(product.id));
        VideoForm.append("title",product.make + " " + product.model);
        VideoForm.append("subtitle",product.reference);

         setIsUploading(true);
         setUploadError(null);
         
         dispatch(videoAdded(VideoForm))
            .then(function(response){
                if(response.type == "videos/videoAdded/fulfilled"){
                    console.log(response);
                    dispatch(productUpdated(response.payload.entity));
       
                } else {
                    setUploadError(response.error.message);
                }
                setIsUploading(false);
                setFile(null);
            });
    }

    return (
    <>
    { !isUploading && 
        
        <label htmlFor="contained-button-video-file">
            <UploadInput 
                accept="video/*" 
                id="contained-button-video-file"
                type="file"
                onChange={chooseVideo}
                />
            <Button variant="contained" component="span">
                Add video
            </Button>
        </label>
        
    }
    { (file && !isUploading) &&
    <Button 
        variant="contained"
        sx={{ml:1}}
        onClick={uploadVideo}
        >
        Upload
    </Button>
    
    }
    { isUploading && (<><CircularProgress /><Typography variant="pgreen" sx={{ml:1}}>Please wait...</Typography></>)}
    { uploadError && (<Typography variant="pred" sx={{ml:1}}>{uploadError}</Typography>)}
    
    { file && 
    (<>
    
    <Box sx={{mt:2,mb:2}}>
    <Typography variant="h4" sx={{mb:1,mt:1}}>Video to upload</Typography>
        <UploadVideoList 
            file={file} 
            onDelete={deleteChoosenVideo}/>
    </Box>
    </>
    )}   
    </>
    )
}
export default UploadVideo;

